import { createComponent } from '@front/utils/alpine';
const Product = createComponent(() => ({
    first: false,
    colorsMediasMeta: document.querySelector('meta[name="product-colors-medias"]'),
    colorsMedias: [],
    selectedMedias: new Set(),
    mainSlider: document.querySelector('.js-slider-main'),
    thumbsSlider: document.querySelector('.js-product-thumbs-slider'),
    modalSlider: document.querySelector('.js-product-modal-slider'),
    mainSlides: [],
    modalSlides: [],
    thumbsSlides: [],
    init() {
        this.colorsMedias = this.colorsMediasMeta
            ? JSON.parse(this.colorsMediasMeta.content)
            : [];
        this.mainSlides = Array.from(this.mainSlider.querySelectorAll('.js-product-slide'));
        this.modalSlides = Array.from(this.modalSlider.querySelectorAll('.js-product-slide'));
        this.thumbsSlides = Array.from(this.thumbsSlider.querySelectorAll('.js-product-slide'));
    },
    getColorSlides(slides) {
        const sortedSlides = Array.from(slides).sort((a, b) => {
            return (parseInt(b.dataset.index) -
                parseInt(a.dataset.index));
        });
        const selected = [];
        const notSelected = [];
        for (const slide of sortedSlides) {
            const mediaId = parseInt(slide.dataset.mediaId);
            if (this.selectedMedias.has(mediaId)) {
                selected.push(slide);
            }
            else {
                notSelected.push(slide);
            }
        }
        return [...selected, ...notSelected].map((el, index) => {
            el.dataset.slideIndex = index.toString();
            return el;
        });
    },
    addSlide(slider, slides) {
        this.first = true;
        slides.forEach((item) => {
            slider.appendChild(item);
            if (this.first &&
                slider.classList.contains('js-product-thumbs-slider')) {
                const clickEvent = new Event('click');
                setTimeout(() => item.dispatchEvent(clickEvent), 150);
            }
            this.first = false;
        });
    },
    removeAllSlides(slider) {
        const slides = slider.querySelectorAll('.js-product-slide');
        slides.forEach((item) => {
            item.remove();
        });
    },
    showColorMedias(id) {
        if (this.colorsMedias.length <= 1) {
            return false;
        }
        this.selectedMedias.clear();
        this.removeAllSlides(this.mainSlider);
        this.removeAllSlides(this.thumbsSlider);
        this.removeAllSlides(this.modalSlider);
        const currentSelection = this.colorsMedias.find((colorMedia) => colorMedia.color_id == id);
        if (currentSelection) {
            currentSelection.medias_ids.forEach((mediaId) => {
                this.selectedMedias.add(mediaId);
            });
        }
        if (this.selectedMedias.size > 0) {
            this.addSlide(this.mainSlider, this.getColorSlides(this.mainSlides));
            this.addSlide(this.modalSlider, this.getColorSlides(this.modalSlides));
            this.addSlide(this.thumbsSlider, this.getColorSlides(this.thumbsSlides));
        }
        else {
            this.addSlide(this.mainSlider, this.mainSlides);
            this.addSlide(this.modalSlider, this.modalSlides);
            this.addSlide(this.thumbsSlider, this.thumbsSlides);
        }
    },
}));
export { Product };
